import { AureliaNotification } from 'aurelia2-notification';
import Aurelia from 'aurelia';
import { RouterConfiguration } from '@aurelia/router';
import { ValidationHtmlConfiguration } from '@aurelia/validation-html';
import { MyApp } from './my-app';
import { Components } from './resources';
import { ConfigureStartup } from './startup';

Aurelia.register(
    RouterConfiguration.customize({
        useUrlFragmentHash: false,
        title: '${componentTitles}${appTitleSeparator}IA Online Quoting',
    }),
    ValidationHtmlConfiguration,
    AureliaNotification.configure({
        translate: false,
        notifications: {
            success: 'humane-jackedup-success',
            error: 'humane-jackedup-error',
            info: 'humane-jackedup-info',
        },
    }),
    ConfigureStartup,
    ...Components
)
    .app(MyApp)
    .start();
